

import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

// The generic Form component that does all the heavy lifting.
import Form from "../../../site/forms/independent/form.jsx"; 

// All form configuration is imported from the module file.
// When module.js is updated, this component automatically gets the new configuration.
import {
  calculationRules,
  formFields, // This now includes the new vendor_type field configuration.
  formHeading,
  submitApi,
  validationRules,
} from "./module";

import { getToken } from "../../../../utils/auth"; 

function CustomerForm() {
  const [data, setData] = useState(null);
  const { rowId } = useParams();

  // This useEffect is for fetching data when editing an existing customer.
  // It remains unchanged.
  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!rowId) return;
        const token = getToken();
        const response = await fetch(`${submitApi}/${rowId}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.ok) {
          const result = await response.json();
          // The result from the API will contain a vendor_type ID (e.g., "1").
          // The generic Form component will use this ID to pre-select the correct option in the dropdown.
          setData(result);
        } else {
          console.error("API Error:", response.statusText);
        }
      } catch (error) {
        console.error("Network or unexpected error:", error);
      }
    };

    fetchData();
  }, [rowId]);

  // The component simply passes the imported configuration down to the Form component.
  // The root of the problem is inside the <Form> component, which is not correctly
  // interpreting the configuration provided in 'formFields'.
  return (
    <Form
      formFields={formFields}
      submitApi={submitApi}
      formHeading={formHeading}
      validationRules={validationRules}
      calculationRules={calculationRules}
      data={data}
    />
  );
}

export default CustomerForm;

